export enum LoaderVariantsEnum {
    PURPLE = 'purple',
    DARK_PURPLE = 'dark-purple',
    LIGHT_PURPLE = 'light-purple',
    WHITE = 'white',
    BLACK = 'black',
}
